/** One mounted configuration workspace may defer a context change until its form is resolved. */
export const configurationNavigationEvent = "shadow:configuration-navigation";
export function requestConfigurationNavigation(
	proceed: () => void,
	cancel?: () => void,
) {
	const event = new CustomEvent<{ cancel?: () => void; proceed: () => void }>(
		configurationNavigationEvent,
		{
			cancelable: true,
			detail: { cancel, proceed },
		},
	);
	if (window.dispatchEvent(event)) proceed();
}
